// This is a higher order component to create a generic form structure with 3 columns
import { FC, ReactElement } from 'react'

export const FormFrame = (Comp1: FC<any>, Comp2: FC<any>, Comp3: FC<any>) => {
    return (props: { [s: string]: any }) => {
        return (
            <div className="mt-0 row">
                {/* ======================================= Col 1 ================================================  */}
                <div id="fourth" className="col-lg-3 col-xxl-3">
                    <Comp1 {...props} />
                </div>
                {/* ======================================= End Col 1 ================================================  */}
                <div id="rightContainer" className="col-lg-9 col-xxl-9">
                    <div className="row">
                        {/* ======================================= Col 2 ================================================  */}
                        <div id="innerRight" className="col-lg-6 col-xxl-6 mt-0">
                            <Comp2 {...props} />
                        </div>
                        {/* ======================================= End Col 2 ================================================  */}
                        {/* ======================================= Col 3 ================================================  */}
                        <div
                            id="innerLeft"
                            className="col-lg-6 col-xxl-6 d-flex section-border-left flex-column mt-0"
                        >
                            <Comp3 {...props} />
                        </div>
                        {/* ======================================= End Col 3 ================================================  */}
                    </div>
                </div>
            </div>
        )
    }
}
